import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';

import { environment } from '../environments/environment';
import { AlertService } from './shared/services/alert.service';
import { AuthService } from './auth';
import {
  UserModel,
  GeneralSettingsModel,
  JwTokenModel,
} from './core/api/models';
import {
  ActivatedRoute,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { AccountApiService } from './core/api/services';
import { OfflineDataService } from './core/services/offline-data.service';
import { MiniProfilerService } from './core/services/mini-profiler.service';
import { AppVersionService } from './core/services/app-version.service';
import { SparkNativeBridgeService } from './core/services/spark-native-bridge.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: false,
})
export class AppComponent implements OnInit {
  public isSignedIn: boolean = false;
  private subscription!: Subscription;
  message: any = null;

  logoURL: string = '/assets/OPTO Logo.png';

  userInfo: UserModel | null = null;
  generalSettings: GeneralSettingsModel | null = null;


  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private messageService: MessageService,
    private authService: AuthService,
    private accountApiService: AccountApiService,
    private offlineDataService: OfflineDataService,
    private profiler: MiniProfilerService,
    private appVersionService: AppVersionService,
    _sparkNativeBridge: SparkNativeBridgeService
    
  ) {
    console.debug('AppComponent.constructor');
  }

  ngOnInit() {
    if (!environment.production)
      this.profiler.init();


    this.authService.getSettings().subscribe((settings) => {
      this.generalSettings = settings;
      this.logoURL = settings?.BusinessLogoUrl || '/assets/OPTO Logo.png';
    });

    this.subscription = this.alertService.getMessage().subscribe((message) => {
      this.message = message;
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationError) {
        console.error(event.error);
        this.router.navigate(['/'], {
          queryParams: { errorMessage: event.error?.message },
        });
        this.alertService.error(event.error?.message ?? 'Navigation error');
        return;
      }
      if (event instanceof NavigationEnd) {
        let urlTree = this.router.parseUrl(event.urlAfterRedirects);
        let parameters = JSON.stringify(urlTree.queryParams);
        urlTree.queryParams = {};
        let cleanUrl = urlTree.toString();

        if (this.authService.userInfo?.Permissions != null) {
          let permissions = this.authService.userInfo?.Permissions;
          var isSparkUser = permissions.includes(3601) || permissions.includes(3602);
          if (!isSparkUser) {
            this.router.navigate(['/not-authorized']);
          }
        }

        let context = JSON.stringify({
          UserID: this.authService.userInfo?.ID,
          TokenExpiresAt: this.authService.tokenInfo?.expires_at,
          RefreshExpiresAt: this.authService.tokenInfo?.refresh_expires_at,
          //localStorage.getItem('currentUser');
        });

        if (!this.offlineDataService.isInOfflineMode()) {
          this.accountApiService
            .LogNavigation({
              body: {
                Url: cleanUrl,
                Parameters: parameters,
                Method: 'ROUTE',
                Context: context,
              },
            })
            .forEach(() => { });
        }
        (window as any).NavigationRouterState = 'NavigationEnd: ' + cleanUrl;
      } else if (event instanceof NavigationStart) {
        (window as any).NavigationRouterState = 'NavigationStart';
        if (!environment.production) {
          this.profiler.clear();
        }

      } else if (event instanceof NavigationCancel) {
        (window as any).NavigationRouterState = 'NavigationCancel';
      } else if (event instanceof NavigationError) {
        (window as any).NavigationRouterState = 'NavigationError';
      }
      console.debug((window as any).NavigationRouterState);
    });

    this.appVersionService.initialize();
    this.appVersionService.updateAvailable$().subscribe((hasUpdate) => {
      if (hasUpdate) {
        this.alertService.info(
          'A new version of ArkMed Spark is ready. Open Menu and tap "Update App" when convenient.'
        );
      }
    });
    this.appVersionService.checkForUpdate().catch(() => {});

  }

  ngAfterViewInit(): void {
    console.debug('AppComponent.AfterViewInit');
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  onConfirm() {
    this.messageService.clear('confirmToat');

    this.alertService.$confirm.next(true);

    this.alertService.$confirm.complete();
  }
  onReject() {
    this.messageService.clear('confirmToat');
    this.messageService.clear('optionToast');
    this.alertService.$confirm.next(false);
    this.alertService.$option.next('');

    this.alertService.$confirm.complete();
    this.alertService.$option.complete();
  }
  clearMessage() {
    this.messageService.clear('confirmToat');
    this.messageService.clear('optionToast');
    this.message = null;
  }
  onOptionSelected(option: string) {
    this.messageService.clear('optionToast');
    this.alertService.$option.next(option);
    this.alertService.$option.complete();
  }

}
